import { Component } from '@angular/core';

@Component({
    selector: 'app-employment-history-dialog',
    templateUrl: './employment-history-dialog.component.html',
    styleUrls: ['./employment-history-dialog.component.scss'],
    standalone: false
})
export class EmploymentHistoryDialogComponent {
}
